import {
  CREATE_CONTACT_FAILED,
  CREATE_CONTACT_REQ,
  CREATE_CONTACT_SUCCESS,
  LIST_CONTACT_FAILED,
  LIST_CONTACT_REQ,
  LIST_CONTACT_SUCCESS,
} from "../Constants/contactConstant";
import axiosConfig from "../Core/axiosConfig";
import { isArray } from "jquery";

export const sendContact = (contactData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CONTACT_REQ });
    const { data } = await axiosConfig.post(
      "/sendaffiliatepartner",
      contactData
    );
    dispatch({ type: CREATE_CONTACT_SUCCESS, payload: data?.Result });
  } catch (error) {
    dispatch({
      type: CREATE_CONTACT_FAILED,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const listContact = (contactFilter) => async (dispatch) => {
  try {
    dispatch({ type: LIST_CONTACT_REQ });
    const { data } = await axiosConfig.post(
      "/sendaffiliatepartner/getContacts",
      contactFilter
    );

    const res = await axiosConfig.post(
      "/sendaffiliatepartner/getContacts/total",
      contactFilter
    );
    if (!isArray(data?.Result) && data?.Result?.include("Error")) {
      dispatch({ type: LIST_CONTACT_FAILED, payload: data?.Result });
    } else {
      dispatch({
        type: LIST_CONTACT_SUCCESS,
        payload: data?.Result,
        total: res?.data?.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: LIST_CONTACT_FAILED,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
